import { mapGetters } from 'vuex';
import whatIsNewFlowVersion1Mixin from './mixin';

export default {
  mixins: [whatIsNewFlowVersion1Mixin],
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
  },
};



// WEBPACK FOOTER //
// ./src/components/what-is-new-popup/flows/what-is-new-flow-version-1/what-is-new-flow-version-1-footer.js